/* Generateur photo -> peinture par numeros, page /pages/paint-by-numbers-generator.
   Tout tourne dans le navigateur : la photo n'est envoyee nulle part.
   Etapes : reduction, lissage, palette (median cut + k-means), filtre majoritaire,
   fusion des zones trop petites pour un pinceau, puis placement des numeros au
   point le plus eloigne des bords de chaque zone. */
(function () {
  var racine = document.getElementById('pbn-gen');
  if (!racine) return;

  var $ = function (s) { return racine.querySelector(s); };
  var etat = { img: null, nom: '', res: null, vue: 'trait' };
  var T = {};
  try { T = JSON.parse(racine.getAttribute('data-t') || '{}'); } catch (e) {}
  function t(cle, defaut, v) {
    var s = T[cle] || defaut;
    return s.replace(/\{(\w+)\}/g, function (x, k) { return v && k in v ? v[k] : x; });
  }

  /* Cote long de travail, aire minimale et rayon minimal d'une zone, par niveau
     de detail. L'aire ne suffit pas : une bande de 2 px peut couvrir 300 px sans
     laisser la place d'un chiffre. Le rayon est celui du plus grand disque inscrit,
     en pixels de travail, regle pour qu'un numero a 2 chiffres tienne a 4 pt au
     moins sur le PDF Letter (rayon = 0,5 + 2,72 / echelle pt par pixel). */
  var NIVEAUX = {
    simple: { cote: 520, aire: 90, rayon: 2.6 },
    moyen: { cote: 760, aire: 110, rayon: 3.5 },
    fin: { cote: 1000, aire: 130, rayon: 4.4 }
  };

  /* Demi-diagonale du numero, rapportee a la taille de police (chiffres Lato ou
     Arial : 0,556 em de large, 0,72 em de haut). */
  function demiDiag(n) {
    var l = 0.278 * String(n).length;
    return Math.sqrt(l * l + 0.36 * 0.36);
  }

  function reduire(img, cote) {
    var w0 = img.naturalWidth, h0 = img.naturalHeight;
    var f = Math.min(1, cote / Math.max(w0, h0));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w0 * f));
    c.height = Math.max(1, Math.round(h0 * f));
    var x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(img, 0, 0, c.width, c.height);
    return c;
  }

  /* Flou boite separable, rayon r : enleve le grain du capteur qui creerait
     des confettis impossibles a peindre. */
  function flou(d, w, h, r) {
    var tmp = new Float32Array(w * h * 3), out = new Float32Array(w * h * 3);
    var x, y, c, s, n, i;
    for (y = 0; y < h; y++) {
      for (c = 0; c < 3; c++) {
        s = 0; n = 0;
        for (x = -r; x <= r; x++) if (x >= 0 && x < w) { s += d[(y * w + x) * 4 + c]; n++; }
        for (x = 0; x < w; x++) {
          tmp[(y * w + x) * 3 + c] = s / n;
          var sort = x - r, entre = x + r + 1;
          if (sort >= 0) { s -= d[(y * w + sort) * 4 + c]; n--; }
          if (entre < w) { s += d[(y * w + entre) * 4 + c]; n++; }
        }
      }
    }
    for (x = 0; x < w; x++) {
      for (c = 0; c < 3; c++) {
        s = 0; n = 0;
        for (y = -r; y <= r; y++) if (y >= 0 && y < h) { s += tmp[(y * w + x) * 3 + c]; n++; }
        for (y = 0; y < h; y++) {
          out[(y * w + x) * 3 + c] = s / n;
          i = y - r; var e = y + r + 1;
          if (i >= 0) { s -= tmp[(i * w + x) * 3 + c]; n--; }
          if (e < h) { s += tmp[(e * w + x) * 3 + c]; n++; }
        }
      }
    }
    return out;
  }

  function medianCut(pts, k) {
    var seaux = [pts];
    while (seaux.length < k) {
      var choisi = -1, meilleur = -1, canal = 0;
      for (var i = 0; i < seaux.length; i++) {
        var b = seaux[i];
        if (b.length < 2) continue;
        var mn = [255, 255, 255], mx = [0, 0, 0];
        for (var j = 0; j < b.length; j++) for (var c = 0; c < 3; c++) {
          if (b[j][c] < mn[c]) mn[c] = b[j][c];
          if (b[j][c] > mx[c]) mx[c] = b[j][c];
        }
        var ca = 0, t = mx[0] - mn[0];
        if (mx[1] - mn[1] > t) { ca = 1; t = mx[1] - mn[1]; }
        if (mx[2] - mn[2] > t) { ca = 2; t = mx[2] - mn[2]; }
        var sc = t * Math.log(b.length + 1);
        if (sc > meilleur) { meilleur = sc; choisi = i; canal = ca; }
      }
      if (choisi < 0 || meilleur <= 0) break;
      var bb = seaux[choisi];
      bb.sort(function (p, q) { return p[canal] - q[canal]; });
      var m = bb.length >> 1;
      seaux.splice(choisi, 1, bb.slice(0, m), bb.slice(m));
    }
    return seaux.map(function (b) {
      var r = 0, g = 0, bl = 0;
      for (var i = 0; i < b.length; i++) { r += b[i][0]; g += b[i][1]; bl += b[i][2]; }
      return [r / b.length, g / b.length, bl / b.length];
    });
  }

  /* Distance ponderee : l'oeil distingue mieux les verts que les bleus. */
  function proche(pal, r, g, b) {
    var best = 0, dist = Infinity;
    for (var c = 0; c < pal.length; c++) {
      var dr = r - pal[c][0], dg = g - pal[c][1], db = b - pal[c][2];
      var v = 2 * dr * dr + 4 * dg * dg + 3 * db * db;
      if (v < dist) { dist = v; best = c; }
    }
    return best;
  }

  function kmeans(pts, pal, tours) {
    for (var t = 0; t < tours; t++) {
      var som = pal.map(function () { return [0, 0, 0, 0]; });
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], c = proche(pal, p[0], p[1], p[2]);
        som[c][0] += p[0]; som[c][1] += p[1]; som[c][2] += p[2]; som[c][3]++;
      }
      pal = pal.map(function (ancien, c) {
        var s = som[c];
        return s[3] ? [s[0] / s[3], s[1] / s[3], s[2] / s[3]] : ancien;
      });
    }
    return pal;
  }

  /* Filtre majoritaire 3x3 : un pixel isole prend la couleur de ses voisins. */
  function majorite(idx, w, h, k) {
    var out = new Uint8Array(idx.length), cpt = new Uint16Array(k);
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var touches = [];
      for (var dy = -1; dy <= 1; dy++) {
        var yy = y + dy; if (yy < 0 || yy >= h) continue;
        for (var dx = -1; dx <= 1; dx++) {
          var xx = x + dx; if (xx < 0 || xx >= w) continue;
          var v = idx[yy * w + xx];
          if (!cpt[v]) touches.push(v);
          cpt[v]++;
        }
      }
      var cur = idx[y * w + x], best = cur, n = cpt[cur];
      for (var t = 0; t < touches.length; t++) if (cpt[touches[t]] > n) { n = cpt[touches[t]]; best = touches[t]; }
      for (t = 0; t < touches.length; t++) cpt[touches[t]] = 0;
      out[y * w + x] = best;
    }
    return out;
  }

  /* Composantes connexes en 4-voisinage. */
  function etiqueter(idx, w, h) {
    var lab = new Int32Array(w * h).fill(-1), tailles = [], pile = new Int32Array(w * h);
    var n = 0;
    for (var s = 0; s < w * h; s++) {
      if (lab[s] >= 0) continue;
      var col = idx[s], haut = 0, taille = 0;
      pile[haut++] = s; lab[s] = n;
      while (haut) {
        var p = pile[--haut]; taille++;
        var x = p % w, y = (p - x) / w;
        if (x > 0 && lab[p - 1] < 0 && idx[p - 1] === col) { lab[p - 1] = n; pile[haut++] = p - 1; }
        if (x < w - 1 && lab[p + 1] < 0 && idx[p + 1] === col) { lab[p + 1] = n; pile[haut++] = p + 1; }
        if (y > 0 && lab[p - w] < 0 && idx[p - w] === col) { lab[p - w] = n; pile[haut++] = p - w; }
        if (y < h - 1 && lab[p + w] < 0 && idx[p + w] === col) { lab[p + w] = n; pile[haut++] = p + w; }
      }
      tailles.push(taille); n++;
    }
    return { lab: lab, tailles: tailles };
  }

  /* Une zone trop petite ou trop etroite prend la couleur de la zone voisine avec
     qui elle partage le plus de bord. Les zones passent une par une, de la plus
     petite a la plus grande, et lisent la couleur actuelle du voisin : deux
     bandes voisines ne peuvent plus echanger leurs couleurs et rester etroites. */
  function fusionner(idx, w, h, aire, rayon) {
    for (var passe = 0; passe < 12; passe++) {
      var e = etiqueter(idx, w, h), lab = e.lab, tailles = e.tailles, nz = tailles.length;
      var d = profondeur(lab, w, h), fond = new Float32Array(nz), couleur = new Uint8Array(nz);
      for (var p = 0; p < w * h; p++) {
        if (d[p] > fond[lab[p]]) fond[lab[p]] = d[p];
        couleur[lab[p]] = idx[p];
      }
      var petite = function (l) { return tailles[l] < aire || fond[l] / 3 < rayon; };
      var voisins = {}, liste = [];
      for (p = 0; p < w * h; p++) {
        var l = lab[p];
        if (!petite(l)) continue;
        var x = p % w, y = (p - x) / w;
        var vs = [x > 0 ? p - 1 : -1, x < w - 1 ? p + 1 : -1, y > 0 ? p - w : -1, y < h - 1 ? p + w : -1];
        for (var i = 0; i < 4; i++) {
          var q = vs[i];
          if (q < 0 || lab[q] === l) continue;
          var m = voisins[l];
          if (!m) { m = voisins[l] = {}; liste.push(l); }
          m[lab[q]] = (m[lab[q]] || 0) + 1;
        }
      }
      if (!liste.length) return idx;
      liste.sort(function (a, b) { return tailles[a] - tailles[b]; });
      for (i = 0; i < liste.length; i++) {
        var z = liste[i], m2 = voisins[z], best = -1, n = -1;
        for (var v in m2) if (m2[v] > n) { n = m2[v]; best = +v; }
        couleur[z] = couleur[best];
      }
      for (p = 0; p < w * h; p++) idx[p] = couleur[lab[p]];
    }
    return idx;
  }

  /* Distance chanfrein 3-4 au bord de la zone : le numero va au point le plus
     profond, la ou il a le plus de place. */
  function profondeur(lab, w, h) {
    var d = new Float32Array(w * h), INF = 1e9, x, y, p;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      p = y * w + x;
      var l = lab[p];
      var bord = x === 0 || y === 0 || x === w - 1 || y === h - 1 ||
        lab[p - 1] !== l || lab[p + 1] !== l || lab[p - w] !== l || lab[p + w] !== l;
      d[p] = bord ? 3 : INF;
    }
    for (y = 1; y < h; y++) for (x = 1; x < w - 1; x++) {
      p = y * w + x; var l2 = lab[p];
      if (lab[p - 1] === l2) d[p] = Math.min(d[p], d[p - 1] + 3);
      if (lab[p - w] === l2) d[p] = Math.min(d[p], d[p - w] + 3);
      if (lab[p - w - 1] === l2) d[p] = Math.min(d[p], d[p - w - 1] + 4);
      if (lab[p - w + 1] === l2) d[p] = Math.min(d[p], d[p - w + 1] + 4);
    }
    for (y = h - 2; y >= 0; y--) for (x = w - 2; x >= 1; x--) {
      p = y * w + x; var l3 = lab[p];
      if (lab[p + 1] === l3) d[p] = Math.min(d[p], d[p + 1] + 3);
      if (lab[p + w] === l3) d[p] = Math.min(d[p], d[p + w] + 3);
      if (lab[p + w + 1] === l3) d[p] = Math.min(d[p], d[p + w + 1] + 4);
      if (lab[p + w - 1] === l3) d[p] = Math.min(d[p], d[p + w - 1] + 4);
    }
    return d;
  }

  function luminance(c) { return 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]; }

  function calculer(img, k, niveau) {
    var N = NIVEAUX[niveau] || NIVEAUX.moyen;
    var src = reduire(img, N.cote), w = src.width, h = src.height;
    var brut = src.getContext('2d').getImageData(0, 0, w, h).data;
    var f = flou(brut, w, h, niveau === 'fin' ? 1 : 2);

    var ech = [], pas = Math.max(1, Math.round(Math.sqrt((w * h) / 20000)));
    for (var y = 0; y < h; y += pas) for (var x = 0; x < w; x += pas) {
      var o = (y * w + x) * 3;
      ech.push([f[o], f[o + 1], f[o + 2]]);
    }
    var pal = kmeans(ech, medianCut(ech.slice(), k), 6);

    var idx = new Uint8Array(w * h);
    for (var p = 0; p < w * h; p++) idx[p] = proche(pal, f[p * 3], f[p * 3 + 1], f[p * 3 + 2]);
    idx = majorite(idx, w, h, pal.length);
    idx = majorite(idx, w, h, pal.length);
    idx = fusionner(idx, w, h, N.aire, N.rayon);

    /* Renumerotation : seules les couleurs encore presentes, du plus clair au
       plus fonce, comme sur une planche de pots. */
    var compte = new Array(pal.length).fill(0);
    for (p = 0; p < w * h; p++) compte[idx[p]]++;
    var utiles = [];
    for (var c = 0; c < pal.length; c++) if (compte[c]) utiles.push(c);
    utiles.sort(function (a, b) { return luminance(pal[b]) - luminance(pal[a]); });
    var nouveau = new Uint8Array(pal.length);
    var palette = utiles.map(function (c, i) {
      nouveau[c] = i;
      return { rgb: pal[c].map(Math.round), part: compte[c] / (w * h) };
    });
    for (p = 0; p < w * h; p++) idx[p] = nouveau[idx[p]];

    var e = etiqueter(idx, w, h), lab = e.lab;
    var d = profondeur(lab, w, h);
    var zones = e.tailles.map(function () { return { p: -1, d: -1 }; });
    for (p = 0; p < w * h; p++) {
      var z = zones[lab[p]];
      if (d[p] > z.d) { z.d = d[p]; z.p = p; }
    }
    var numeros = zones.map(function (z) {
      var x = z.p % w, n = idx[z.p] + 1;
      /* fs : plus grande police dont le numero tient dans le disque inscrit,
         de rayon d/3 - 0,5 (d/3 se mesure au centre du pixel voisin). */
      return { x: x + 0.5, y: (z.p - x) / w + 0.5, r: z.d / 3, n: n, fs: (z.d / 3 - 0.5) / demiDiag(n) };
    });

    return { w: w, h: h, idx: idx, palette: palette, numeros: numeros, zones: zones.length };
  }

  /* Rendu a l'echelle s. Les traits suivent les bords des pixels, regroupes en
     segments continus pour rester legers. */
  function dessiner(res, s, mode) {
    var w = res.w, h = res.h, idx = res.idx, pal = res.palette;
    var c = document.createElement('canvas');
    c.width = Math.round(w * s); c.height = Math.round(h * s);
    var x = c.getContext('2d');
    x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);

    if (mode === 'couleur') {
      var small = document.createElement('canvas');
      small.width = w; small.height = h;
      var id = new ImageData(w, h);
      for (var p = 0; p < w * h; p++) {
        var col = pal[idx[p]].rgb;
        id.data[p * 4] = col[0]; id.data[p * 4 + 1] = col[1]; id.data[p * 4 + 2] = col[2]; id.data[p * 4 + 3] = 255;
      }
      small.getContext('2d').putImageData(id, 0, 0);
      x.imageSmoothingEnabled = false;
      x.drawImage(small, 0, 0, c.width, c.height);
      return c;
    }

    x.beginPath();
    var yy, xx, debut;
    for (yy = 1; yy < h; yy++) {
      debut = -1;
      for (xx = 0; xx <= w; xx++) {
        var diff = xx < w && idx[yy * w + xx] !== idx[(yy - 1) * w + xx];
        if (diff && debut < 0) debut = xx;
        if (!diff && debut >= 0) { x.moveTo(debut * s, yy * s); x.lineTo(xx * s, yy * s); debut = -1; }
      }
    }
    for (xx = 1; xx < w; xx++) {
      debut = -1;
      for (yy = 0; yy <= h; yy++) {
        var diff2 = yy < h && idx[yy * w + xx] !== idx[yy * w + xx - 1];
        if (diff2 && debut < 0) debut = yy;
        if (!diff2 && debut >= 0) { x.moveTo(xx * s, debut * s); x.lineTo(xx * s, yy * s); debut = -1; }
      }
    }
    x.strokeStyle = '#8c8c8c';
    x.lineWidth = Math.max(0.6, s * 0.35);
    x.stroke();
    x.strokeRect(0, 0, c.width, c.height);

    if (mode === 'trait') {
      x.fillStyle = '#555';
      x.textAlign = 'center'; x.textBaseline = 'middle';
      res.numeros.forEach(function (n) {
        var fs = Math.min(14, n.fs) * s;
        x.font = fs + 'px Lato, Arial, sans-serif';
        x.fillText(String(n.n), n.x * s, n.y * s);
      });
    }
    return c;
  }

  function hex(rgb) {
    return '#' + rgb.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
  }

  /* ---------- interface ---------- */

  function message(texte, ton) {
    var m = $('.pbn-msg');
    m.className = 'pbn-msg' + (ton ? ' pbn-msg--' + ton : '');
    m.innerHTML = texte;
    m.hidden = !texte;
  }

  function verdictPhoto(fichier, img) {
    var l = img.naturalWidth, h = img.naturalHeight, grand = Math.max(l, h);
    if (grand < 900) {
      return [t('petite', 'This photo is {l} × {h} px. Fine for a printout at home, too small for a canvas: our kits need about 900 px on the long side. The original from your phone gallery usually has plenty.', { l: l, h: h }), 'tiede'];
    }
    /* le ratio octets/pixel ne dit quelque chose que pour un JPEG : un PNG en aplats est petit sans etre degrade */
    if (/jpe?g/i.test(fichier.type || fichier.name) && fichier.size / (l * h) < 0.08) {
      return [t('compressee', 'The file is heavily compressed ({kb} KB for {l} × {h} px), typical of a photo sent through a messaging app. Faces lose detail first.', { kb: Math.round(fichier.size / 1024), l: l, h: h }), 'tiede'];
    }
    return [t('bonne', 'Good photo: {l} × {h} px, enough for any of our canvas sizes.', { l: l, h: h }), 'ok'];
  }

  function relancer() {
    if (!etat.img) return;
    var k = +$('[name=pbn-k]:checked').value;
    var niveau = $('[name=pbn-niveau]:checked').value;
    racine.classList.add('is-calcul');
    setTimeout(function () {
      var t0 = performance.now();
      etat.res = calculer(etat.img, k, niveau);
      etat.ms = Math.round(performance.now() - t0);
      afficher();
      racine.classList.remove('is-calcul');
    }, 30);
  }

  function afficher() {
    var res = etat.res, ecran = $('.pbn-ecran');
    var s = Math.min(3, Math.max(1, (ecran.clientWidth * (window.devicePixelRatio || 1)) / res.w));
    var c = etat.vue === 'photo' ? reduire(etat.img, res.w * s) : dessiner(res, s, etat.vue);
    c.className = 'pbn-toile';
    ecran.innerHTML = '';
    ecran.appendChild(c);

    $('.pbn-stats').textContent = t('stats', '{n} colors, {z} areas to paint.', { n: res.palette.length, z: res.zones });
    var ul = $('.pbn-palette');
    ul.innerHTML = res.palette.map(function (c, i) {
      return '<li><span style="background:' + hex(c.rgb) + '"></span><b>' + (i + 1) + '</b><i>' + hex(c.rgb) + '</i></li>';
    }).join('');
    $('.pbn-resultat').hidden = false;
  }

  function charger(fichier) {
    if (!fichier) return;
    if (!/^image\//.test(fichier.type) && !/\.(heic|heif)$/i.test(fichier.name)) {
      message(t('pas_image', 'That file is not an image. JPG, PNG or WebP work everywhere.'), 'dur');
      return;
    }
    var url = URL.createObjectURL(fichier);
    var img = new Image();
    img.onload = function () {
      etat.img = img; etat.nom = (fichier.name || 'photo').replace(/\.[^.]+$/, '');
      var v = verdictPhoto(fichier, img);
      message(v[0], v[1]);
      relancer();
    };
    img.onerror = function () {
      message(/heic|heif/i.test(fichier.name + fichier.type)
        ? t('heic', 'This browser cannot open HEIC photos. On iPhone, open this page in Safari, or set Camera > Formats to "Most Compatible".')
        : t('illisible', 'This image could not be opened. Try saving it again as JPG.'), 'dur');
    };
    img.src = url;
  }

  function chargerScript(src) {
    return new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = src; s.onload = ok; s.onerror = ko;
      document.head.appendChild(s);
    });
  }

  /* PDF au format Letter : page 1 la toile numerotee, page 2 la palette et
     l'apercu peint pour se reperer. */
  function pdf() {
    var b = $('.pbn-pdf');
    b.disabled = true; b.dataset.label = b.textContent; b.textContent = t('pdf_prep', 'Preparing the PDF…');
    var go = window.jspdf ? Promise.resolve() : chargerScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
    go.then(function () {
      var res = etat.res, J = window.jspdf.jsPDF;
      var paysage = res.w > res.h;
      var doc = new J({ orientation: paysage ? 'landscape' : 'portrait', unit: 'pt', format: 'letter' });
      var W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight(), m = 30;
      var f = Math.min((W - 2 * m) / res.w, (H - 2 * m - 14) / res.h);
      var lw = res.w * f, lh = res.h * f, ox = (W - lw) / 2, oy = m;

      var trait = dessiner(res, 2400 / Math.max(res.w, res.h), 'contour');
      doc.addImage(trait.toDataURL('image/png'), 'PNG', ox, oy, lw, lh, undefined, 'FAST');
      doc.setTextColor(70);
      res.numeros.forEach(function (n) {
        var fs = Math.min(11, n.fs * f);
        doc.setFontSize(fs);
        doc.text(String(n.n), ox + n.x * f, oy + n.y * f, { align: 'center', baseline: 'middle' });
      });
      doc.setFontSize(8); doc.setTextColor(140);
      doc.text(location.host + location.pathname, W / 2, H - 14, { align: 'center' });

      doc.addPage('letter', 'portrait');
      var W2 = doc.internal.pageSize.getWidth();
      doc.setTextColor(30); doc.setFontSize(15);
      doc.text(t('legende', 'Color key'), m, 44);
      var colonnes = 3, cw = (W2 - 2 * m) / colonnes, ligne = 26;
      res.palette.forEach(function (c, i) {
        var col = i % colonnes, row = Math.floor(i / colonnes);
        var x = m + col * cw, y = 66 + row * ligne;
        doc.setFillColor(c.rgb[0], c.rgb[1], c.rgb[2]);
        doc.setDrawColor(180);
        doc.rect(x, y, 30, 18, 'FD');
        doc.setFontSize(11); doc.setTextColor(30);
        doc.text(String(i + 1), x + 38, y + 13);
        doc.setFontSize(9); doc.setTextColor(110);
        doc.text(hex(c.rgb) + '  ' + (c.part * 100).toFixed(1) + '%', x + 58, y + 13);
      });
      var yApercu = 66 + Math.ceil(res.palette.length / colonnes) * ligne + 20;
      var couleur = dessiner(res, 1200 / Math.max(res.w, res.h), 'couleur');
      var f2 = Math.min((W2 - 2 * m) / res.w, (doc.internal.pageSize.getHeight() - yApercu - 40) / res.h);
      if (f2 > 0.05) doc.addImage(couleur.toDataURL('image/jpeg', 0.85), 'JPEG', (W2 - res.w * f2) / 2, yApercu, res.w * f2, res.h * f2);
      doc.save((etat.nom || 'photo') + t('fichier', '-paint-by-numbers') + '.pdf');
    }).catch(function () {
      message(t('pdf_ko', 'The PDF library did not load. Check your connection and try again.'), 'dur');
    }).then(function () {
      b.disabled = false; b.textContent = b.dataset.label;
    });
  }

  var entree = $('#pbn-fichier');
  entree.addEventListener('change', function () { charger(entree.files[0]); });
  var depot = $('.pbn-depot');
  ['dragenter', 'dragover'].forEach(function (t) {
    depot.addEventListener(t, function (e) { e.preventDefault(); depot.classList.add('is-survol'); });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    depot.addEventListener(t, function (e) { e.preventDefault(); depot.classList.remove('is-survol'); });
  });
  depot.addEventListener('drop', function (e) { charger(e.dataTransfer.files[0]); });
  racine.addEventListener('change', function (e) {
    if (e.target.name === 'pbn-k' || e.target.name === 'pbn-niveau') relancer();
  });
  racine.querySelectorAll('[data-vue]').forEach(function (b) {
    b.addEventListener('click', function () {
      etat.vue = b.dataset.vue;
      racine.querySelectorAll('[data-vue]').forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
      if (etat.res) afficher();
    });
  });
  $('.pbn-pdf').addEventListener('click', pdf);

  window.abnPbn = { calculer: calculer, dessiner: dessiner };
})();
